import React from 'react'
import { useInView } from 'react-intersection-observer'

import Breadcrumb from '../breadcrumb'
import Wysiwyg from '../wysiwyg'

import semiroundShape from '../../icons/semiround-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'
import roundShape from '../../icons/round-shape.svg'
import quadShape from '../../icons/quad-shape.svg'


const SimpleHero = ({ data, currentUrl, type, customType, subType }) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const chapo = (data.chapo) ? data.chapo : null
  const breadcrumbLabel = (data.breadcrumbCurrentLabel) ? data.breadcrumbCurrentLabel : data.title

  let semiround1Color = 'night'
  let roundColor = 'beige'
  let hexagonColor = 'gradient-blue'
  let semiround2Color = 'sienne'
  let quadColor = 'turquoise'

  if (type === 'hub') {
    semiround1Color = 'aqua'
    roundColor = 'parma'
    semiround2Color = 'night'
    quadColor = 'orange'
    hexagonColor = 'gradient-sienne2'
  }

  return (
    <section className={`simple-hero ${inView ? 'has-anim' : ''}`} ref={ref}>
      <Breadcrumb 
        currentUrl={currentUrl}
        links={data.breadcrumb ? data.breadcrumb : null} 
        current={breadcrumbLabel} 
        type={type}
        customType={customType}
        subType={subType}
      />

      <div className="relative mt-25">
        <div className="row simple-hero__content">
          <div className="col-12 md-col-9 lg-col-7">
            <h1 className="title title-page title title-page--big mb-5 md:mb-8 scroll-anim-el">{data.title}</h1>

            <Wysiwyg document={chapo} classes="paragraph-big scroll-anim-el scroll-anim-el--2" />
          </div>
        </div>

        <svg className={`absolute icon-${semiround1Color} simple-hero__semiround-left`} width="100" height="118">
          <use xlinkHref={semiroundShape.url} />
        </svg>

        <div className="simple-hero__icons-wrap">
          <svg className={`icon icon-${roundColor} simple-hero__round`} width="58" height="58">
            <use xlinkHref={roundShape.url} />
          </svg>

          <svg className={`icon icon-${hexagonColor} simple-hero__hexagon`} width="200" height="200">
            <use xlinkHref={hexagonShape.url} />
          </svg>

          <svg className={`icon icon-${semiround2Color} simple-hero__semiround`} width="140" height="140">
            <use xlinkHref={semiroundShape.url} />
          </svg>

          <svg className={`icon icon-${quadColor} simple-hero__quad`} width="74" height="74">
            <use xlinkHref={quadShape.url} />
          </svg>
        </div>
      </div>
    </section>
  )
}

export default SimpleHero
